/*
 * @Description: 路由
 * @Date: 2025-03-19 13:35:06
 */
export const route = [
  {
    path: '/main/project-center-list',
    name: 'project-center-list',
    meta: {
      title: '项目中心'
    },
    component: () => import('../views/project-center-list/index')
  }
];
